<template>
  <ul class="px-0">
    <li v-for="(filter, index) in filterList" :key="index">
      <v-chip class="mr-1" color="primary" dense label :outlined="outlined" small>
        {{ filter.attributeNameLabel || filter.attributeName }} {{ filter.operatorLabel || filter.operator }}
        {{ filter.valueLabel || filter.value }}
      </v-chip>
      <v-chip color="transparent" label v-if="index < filterList.length - 1" class="my-1" small>
        <b>AND</b>
      </v-chip>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    filterList: {
      required: true,
      type: Array,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
ul {
  line-height: 200%;
  list-style: none;
}
</style>
